module.exports = __webpack_public_path__ + "img/chat.b2c6905.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/chat.svg
// module id = ./assets/chat.svg
// module chunks = 13